"use client";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

export const Mobile = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const mobile = useMediaQuery({
    query: "(max-width:1023px)",
  });
  useEffect(() => {
    if (mobile) setIsMobile(true);
    else setIsMobile(false);
  }, [mobile]);
  return <>{isMobile && children}</>;
};
export const Pc = ({ children }) => {
  const [isPc, setIsPc] = useState(false);
  const pc = useMediaQuery({
    query: "(min-width:1024px)",
  });
  useEffect(() => {
    if (pc) setIsPc(true);
    else setIsPc(false);
  }, [pc]);
  return <>{isPc && children}</>;
};
